import { useDispatch } from 'react-redux';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { eventActions } from '../../../../store/modules/event';
import { ProductItem, SectionTab } from '../types';

const useEventPreview = ({ form }: FormComponentProps) => {
  const dispatch = useDispatch();

  /**
   *  기획전 미리보기
   */
  const preview = () => {
    const fieldsValue = form.getFieldsValue();

    const sectionInfoList = fieldsValue.sectionTabList.map((tab: SectionTab) => ({
      eventSectionType: tab.type,
      title: fieldsValue[`${tab.name}-title`]?.trim(),
      tabTitle: fieldsValue[`${tab.name}-tabTitle`]?.trim(),
      transitionDelay: fieldsValue[`${tab.name}-transitionDelay`] ?? 0,
      isInfinity: fieldsValue[`${tab.name}-isInfinity`] ?? false,
      eventSectionImg: fieldsValue[`${tab.name}-attachments`] ?? [],
      eventSectionClickLayerList: fieldsValue[`${tab.name}-clickLayers`] ?? [],
      eventSectionItemList:
        fieldsValue[`${tab.name}-product-items`]?.map((item: ProductItem) => ({
          url: item.imageUrl,
          brandName: item.brandName,
          productName: item.name,
          discountRate: item.discountRate,
          salesPrice: item.salesPrice,
        })) ?? [],
    }));

    const eventItemList = fieldsValue['event-product-items']?.map((item: ProductItem) => ({
      url: item.imageUrl,
      brandName: item.brandName,
      productName: item.name,
      discountRate: item.discountRate,
      salesPrice: item.salesPrice,
    }));

    const tabColorSet = {
      background: fieldsValue['sectionTabBackgroundColor'] ?? '#FFFFFF',
      active: fieldsValue['sectionTabActiveColor'] ?? '#000000',
      inactive: fieldsValue['sectionTabInactiveColor'] ?? '#9B9B9B',
    };

    dispatch(
      eventActions.toggleModal({
        name: 'previewEventModal',
        value: true,
        data: {
          eventPreviewData: {
            sectionInfoList,
            eventItemList,
            tabColorSet,
          },
        },
      }),
    );
  };

  return {
    preview,
  };
};

export default useEventPreview;
